import {Component} from '@angular/core';
import {SystemService} from '../../../../services/SystemService';

@Component({
    templateUrl: './KeepingCurrentReportComponent.html',
    standalone: false
})
export class KeepingCurrentReportComponent {

  constructor(public systemService: SystemService) {
  }
}
